import { render, staticRenderFns } from "./ViewProject.vue?vue&type=template&id=705786d9&"
import script from "./ViewProject.vue?vue&type=script&lang=js&"
export * from "./ViewProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports